import React from "react";
import { Backdrop, makeStyles } from '@material-ui/core';

export default function Loader(props) {
  const classes = useStyles();
  const { loading } = props
  return(
    <Backdrop className={classes.backdrop} open={loading}>
        <img src="../../spinner-unio.gif" alt="spinner" width="150px" height="150px"/>
    </Backdrop>
  );
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 100,
      color: '#fff',
    },
}));